import { Activity } from "lucide-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="bg-slate-950 py-12">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <div className="flex flex-col items-start justify-between gap-8 border-b border-white/10 pb-10 md:flex-row">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <img src="/logo.png" alt="Ticker Templates" className="h-9 w-auto" />
            </div>
            <p className="mt-4 text-sm leading-relaxed text-slate-400">
              The live-priced exchange for premium digital templates. Prices tick against the market in real time — you always trade at the best value.
            </p>
          </div>
          <div className="grid grid-cols-2 gap-12 sm:grid-cols-3">
            {[
              { h: "Product", items: ["Marketplace", "Bestsellers", "Autopilot", "Pricing"] },
              { h: "Company", items: ["About", "Careers", "Blog", "Contact"] },
              { h: "Legal", items: ["Terms", "Privacy", "License"] },
            ].map((col) => (
              <div key={col.h}>
                <p className="mb-3 font-mono text-xs uppercase tracking-[0.15em] text-slate-500">
                  {col.h}
                </p>
                <ul className="space-y-2">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a href="#" className="text-sm text-slate-400 transition-colors duration-200 hover:text-white">
                        {it}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col items-center justify-between gap-3 pt-6 sm:flex-row">
          <p className="font-mono text-xs text-slate-500">© 2026 Ticker Templates · tickertemplates.com</p>
          <div className="flex items-center gap-5">
            <Link to="/refer" data-testid="footer-refer-link" className="font-mono text-xs text-emerald-400 transition-colors duration-200 hover:text-emerald-300">
              Refer &amp; Earn →
            </Link>
            <Link to="/admin" className="font-mono text-xs text-slate-500 transition-colors duration-200 hover:text-emerald-400">
              Admin Dashboard →
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
